import _classCallCheck from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _createClass from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _inherits from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import MizzyDevice from "../MizzyDevice";
import Sample from "../Components/Sample";
import SamplePlayer from "../Voices/SamplePlayer";

var VSS30 =
/*#__PURE__*/
function (_MizzyDevice) {
  _inherits(VSS30, _MizzyDevice);

  _createClass(VSS30, null, [{
    key: "LOOP_MODES",
    get: function get() {
      return {
        NORMAL: "NORMAL",
        PINGPONG: "PINGPONG"
      };
    }
  }]);

  function VSS30(context) {
    var _this;

    _classCallCheck(this, VSS30);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(VSS30).call(this, context));
    _this.sample = new Sample(_this.context);
    _this.recording = false;
    _this._loop = true;
    _this._loopMode = VSS30.LOOP_MODES.NORMAL;
    _this._reverse = false;
    _this._loopStart = 0;
    _this._loopEnd = 1;
    _this.samplingProgress = 0;
    return _this;
  }

  _createClass(VSS30, [{
    key: "record",
    value: function record() {
      var _this2 = this;

      var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2000;
      var overdub = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.samplingProgress = 0;
      return new Promise(function (resolve, reject) {
        var requiredSamples = _this2.context.sampleRate * (timeout / 1000);

        if (!_this2.recording) {
          _this2.recording = true;
          _this2.sample.overdub = overdub;

          _this2.sample.record(function (streamLength) {
            _this2.samplingProgress = streamLength / requiredSamples;

            if (streamLength > requiredSamples) {
              _this2.samplingProgress = 1;

              _this2.stopRecording();

              resolve(_this2);
            }
          });
        }
      });
    }
  }, {
    key: "stopRecording",
    value: function stopRecording() {
      if (this.recording) {
        this.recording = false;
        this.sample.stopRecording();
      }
    }
  }, {
    key: "NoteOn",
    value: function NoteOn(MidiEvent) {
      var voice = new SamplePlayer(this.context, this.sample.buffer, this._loop);
      voice.attack = this.attack;
      voice.decay = this.decay;
      voice.sustain = this.sustain;
      voice.release = this.release;
      voice.loopStart = this._loopStart;
      voice.loopEnd = this._loopEnd;
      voice.init();
      voice.connect(this.effectInput);
      voice.on(MidiEvent);
      this.voices[MidiEvent.value] = voice;
    }
  }, {
    key: "toggleReverse",
    value: function toggleReverse() {
      this.sample.reverse();
    }
  }, {
    key: "setSample",
    value: function setSample(sample) {
      this.sample = sample;
      this.setVoiceValues();
    }
  }, {
    key: "setVoiceValues",
    value: function setVoiceValues() {
      var _this3 = this;

      this.voices.forEach(function (voice) {
        voice.attack = _this3._attack;
        voice.decay = _this3._decay;
        voice.sustain = _this3._sustain;
        voice.release = _this3._release;
        voice.loopStart = _this3._loopStart;
        voice.loopEnd = _this3._loopEnd;
      });
    }
  }, {
    key: "loop",
    set: function set(value) {
      this._loop = value;
    },
    get: function get() {
      return this._loop;
    }
  }, {
    key: "loopMode",
    set: function set(value) {
      this._loopMode = value;

      switch (this._loopMode) {
        case VSS30.LOOP_MODES.PINGPONG:
          this.sample.pingpong();
          break;

        case VSS30.LOOP_MODES.NORMAL:
          this.sample.normal();
          break;
      }

      this.setVoiceValues();
    },
    get: function get() {
      return this._loopMode;
    }
  }, {
    key: "loopStart",
    set: function set(value) {
      this._loopStart = value;
      this.setVoiceValues();
    },
    get: function get() {
      return this._loopStart;
    }
  }, {
    key: "loopEnd",
    set: function set(value) {
      this._loopEnd = value;
      this.setVoiceValues();
    },
    get: function get() {
      return this._loopEnd;
    }
  }, {
    key: "loopLength",
    get: function get() {
      return this.sample.buffer.duration;
    }
  }]);

  return VSS30;
}(MizzyDevice);

export { VSS30 as default };